import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const EMPTY = 'Empty'; //////////////////////// 1
const NOT_EMPTY = 'NotEmpty'; ///////////////// 2
const EQUALS = 'Equals'; ////////////////////// 3
const NOT_EQUALS = 'NotEquals'; /////////////// 4
const GREATER = 'Greater'; //////////////////// 5
const GREATER_OR_EQUAL = 'GreaterOrEqual'; //// 6
const LESS = 'Less'; ////////////////////////// 7
const LESS_OR_EQUAL = 'LessOrEqual'; ////////// 8
const IN = 'In'; ////////////////////////////// 9
const NOT_IN = 'NotIn'; ////////////////////// 10
const LIKE = 'Like'; ///////////////////////// 11
const NOT_LIKE = 'NotLike'; ////////////////// 12

const TODAY = 'Today';
const YESTERDAY = 'Yesterday';
const TOMORROW = 'Tomorrow';
const THIS_WEEK = 'ThisWeek';
const LAST_WEEK = 'LastWeek';
const NEXT_WEEK = 'NextWeek';
const THIS_MONTH = 'ThisMonth';
const LAST_MONTH = 'LastMonth';
const NEXT_MONTH = 'NextMonth';
const THIS_QUARTER = 'ThisQuarter';
const LAST_QUARTER = 'LastQuarter';
const NEXT_QUARTER = 'NextQuarter';
const THIS_YEAR = 'ThisYear';
const LAST_YEAR = 'LastYear';
const NEXT_YEAR = 'NextYear';
const INSIDE_RANGE = 'InsideRange';
const OUTSIDE_RANGE = 'OutsideRange';
const NO_DATA_WITHIN_RANGE = 'NoDataWithinRange';
export const DIVIDER = 'DIVIDER';
const commonOperators = {
  label_advanced_filter_option_empty: EMPTY,
  label_advanced_filter_option_informed: NOT_EMPTY
};
export const dateFieldOperators = {
  operators: {
    common_today: TODAY,
    common_yesterday: YESTERDAY,
    common_tomorrow: TOMORROW,
    divider_days: DIVIDER,
    common_this_week: THIS_WEEK,
    common_last_week: LAST_WEEK,
    common_next_week: NEXT_WEEK,
    divider_weeks: DIVIDER,
    common_this_month: THIS_MONTH,
    common_last_month: LAST_MONTH,
    common_next_month: NEXT_MONTH,
    divider_months: DIVIDER,
    common_this_quarter: THIS_QUARTER,
    common_last_quarter: LAST_QUARTER,
    common_next_quarter: NEXT_QUARTER,
    divider_quarters: DIVIDER,
    common_this_year: THIS_YEAR,
    common_last_year: LAST_YEAR,
    common_next_year: NEXT_YEAR,
    divider_years: DIVIDER,
    label_advanced_filter_option_before_than: LESS,
    label_advanced_filter_option_after_than: GREATER,
    divider_advanced: DIVIDER
  }
};
const numberFieldOperators = {
  operators: _objectSpread(_objectSpread({
    label_advanced_filter_option_less_than: LESS,
    label_advanced_filter_option_less_than_equal: LESS_OR_EQUAL,
    label_advanced_filter_option_equal: EQUALS,
    label_advanced_filter_option_not_equal: NOT_EQUALS,
    label_advanced_filter_option_larger_than_equal: GREATER_OR_EQUAL,
    label_advanced_filter_option_larger_than: GREATER
  }, commonOperators), {}, {
    label_advanced_filter_option_outside_range: OUTSIDE_RANGE,
    label_advanced_filter_option_no_data_in_range: NO_DATA_WITHIN_RANGE
  }),
  default: EQUALS
};
const selectFieldOperators = {
  operators: _objectSpread({
    label_advanced_filter_option_contains: IN,
    label_advanced_filter_option_does_not_contain: NOT_IN
  }, commonOperators),
  default: IN
};
export const operators = {
  EMPTY,
  NOT_EMPTY,
  EQUALS,
  NOT_EQUALS,
  GREATER,
  GREATER_OR_EQUAL,
  LESS,
  LESS_OR_EQUAL,
  IN,
  NOT_IN,
  LIKE,
  NOT_LIKE,
  TODAY,
  YESTERDAY,
  TOMORROW,
  THIS_WEEK,
  LAST_WEEK,
  NEXT_WEEK,
  THIS_MONTH,
  LAST_MONTH,
  NEXT_MONTH,
  THIS_QUARTER,
  LAST_QUARTER,
  NEXT_QUARTER,
  THIS_YEAR,
  LAST_YEAR,
  NEXT_YEAR,
  INSIDE_RANGE,
  OUTSIDE_RANGE,
  NO_DATA_WITHIN_RANGE
};
export const fieldOperators = {
  bool: {
    operators: _objectSpread({
      label_advanced_filter_option_equal: EQUALS
    }, commonOperators),
    default: EQUALS
  },
  probability: {
    operators: _objectSpread(_objectSpread({
      label_advanced_filter_option_equal: EQUALS,
      label_advanced_filter_option_less_than: LESS,
      label_advanced_filter_option_less_than_equal: LESS_OR_EQUAL,
      label_advanced_filter_option_not_equal: NOT_EQUALS,
      label_advanced_filter_option_larger_than_equal: GREATER_OR_EQUAL,
      label_advanced_filter_option_larger_than: GREATER
    }, commonOperators), {}, {
      label_advanced_filter_option_outside_range: OUTSIDE_RANGE,
      label_advanced_filter_option_no_data_in_range: NO_DATA_WITHIN_RANGE
    }),
    default: EQUALS
  },
  singleValueList: selectFieldOperators,
  multipleValueList: selectFieldOperators,
  relatedValueList: selectFieldOperators,
  date: {
    operators: _objectSpread(_objectSpread(_objectSpread({}, dateFieldOperators.operators), commonOperators), {}, {
      divider_common: DIVIDER,
      label_advanced_filter_option_inside_range: INSIDE_RANGE,
      label_advanced_filter_option_outside_range: OUTSIDE_RANGE,
      label_advanced_filter_option_no_data_in_range: NO_DATA_WITHIN_RANGE
    }),
    default: INSIDE_RANGE
  },
  singleDate: {
    operators: _objectSpread(_objectSpread({
      label_advanced_filter_option_inside_range: EQUALS
    }, dateFieldOperators.operators), commonOperators),
    default: EQUALS
  },
  text: {
    operators: _objectSpread({
      label_advanced_filter_option_contains: LIKE,
      label_advanced_filter_option_does_not_contain: NOT_LIKE
    }, commonOperators),
    default: LIKE
  },
  integer: numberFieldOperators,
  decimal: numberFieldOperators,
  currency: numberFieldOperators,
  percent: numberFieldOperators
};
export const operatorsToBeShownOnlyInCrossFilters = [OUTSIDE_RANGE, NO_DATA_WITHIN_RANGE];